<ng-container>
  @if (hasFieldNotes('apiNumber')) {
    <div>
      <view-notes [fieldName]="'apiNumber'" [notes]="getFilteredNotes('apiNumber')" (notesRequested)="handleNotesRequested($event)"></view-notes>
    </div>
  }
  <well-selector [organization]="organization" [enableSelections]="enableWellSelection" [reportType]="reportType" (throw)="handleError($event)" (selectedWells)="onWellsSelected($event)"></well-selector>
  @if (wellIsSelected) {
    <app-owner-well-info [application]="application" [form]="form?.get('ownerWellInfo')" [organization]="organization" (notesRequested)="handleNotesRequested($event)"></app-owner-well-info>
    <app-well-information [application]="application" [form]="form?.get('wellInfo')" [organization]="organization" (notesRequested)="handleNotesRequested($event)"></app-well-information>
    <app-casing-and-tubing [form]="form?.get('casingTubing')" [dataTypes]="dataTypes" (notesRequested)="handleNotesRequested($event)" [application]="application"></app-casing-and-tubing>
    <app-formations [form]="form?.get('formations')" [countedItems]="itemList" [methodTypes]="methods" (notesRequested)="handleNotesRequested($event)" [application]="application"></app-formations>
    <app-documentation [form]="form?.get('documentation')" [application]="application" [onBaseDocumentTypes]="onBaseDocumentTypes" (notesRequested)="handleNotesRequested($event)">[reportType]="reportType"></app-documentation>
    @if (isInternal) {
      <app-user-updates [application]="application" [form]="form?.get('userUpdates')" [well]="well"></app-user-updates>
      <app-received-dates [application]="application" [reportType]="reportType" (notesRequested)="handleNotesRequested($event)" [form]="form?.get('receivedDates')"> </app-received-dates>
    }
    @if (!isApproved) {
      <div class="grid-margin-x">
        <app-certification [form]="form?.get('certifications')" [application]="application" [reportType]="reportType" (notesRequested)="handleNotesRequested($event)"></app-certification>
        @switch (true) {
          @case (!isInternal) {
            <div class="large-12 medium-12 small-12 text-align-center">
              <span class="minor-margin-right">
                <button class="button" (click)="save()">Save for Later</button>
              </span>
              <ng-container>
                <span class="minor-margin-right">
                  <button class="button" (click)="submit()" [disabled]="disableSubmit">Submit</button>
                </span>
              </ng-container>
              <span>
                <button class="button" (click)="cancel()">Cancel</button>
              </span>
            </div>
          }
          @case (isInternal) {
            <div class="large-12 medium-12 small-12 text-align-center">
              @if (!isApproved && !isInCorrections) {
                <span class="minor-margin-right">
                  <button class="button" (click)="save()">Save for Later</button>
                </span>
              }
              @if (!isApproved && !isInCorrections) {
                <span class="minor-margin-right">
                  <button class="button" (click)="onAccept()" [disabled]="disableSubmit">Accept</button>
                </span>
              }
              <span>
                <button class="button" (click)="cancel()">Cancel</button>
              </span>
            </div>
          }
        }
      </div>
    }
  }
</ng-container>